/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Subscriptions_Tab_MonthInputs */

const en_admin_subscriptions_tab_month = /** @type {(inputs: Admin_Subscriptions_Tab_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monthly`)
};

/**
* | output |
* | --- |
* | "Monthly" |
*
* @param {Admin_Subscriptions_Tab_MonthInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_subscriptions_tab_month = /** @type {((inputs?: Admin_Subscriptions_Tab_MonthInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Subscriptions_Tab_MonthInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_subscriptions_tab_month(inputs)
});
export { admin_subscriptions_tab_month as "admin.subscriptions.tab_month" }